/**
 * Constants for use by CloudSent POS System Operator Portal
 */

export const FUSE_LIST = 'FUSE_LIST';

export const SET_LIST = 'SET_LIST';


// WEBPACK FOOTER //
// ./src/Fuse/admin/fuseConstants.js